// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/searchkeyword',
    name: 'SearchKeyword',
    component: () => import('../views/SearchKeyword.vue')
  },
  {
    path: '/setting',
    name: 'Setting',
    component: () => import('../views/SettingPage.vue')
  },
  {
    path: '/accountlist',
    name: 'AccountList',
    component: () => import('../views/AccountList.vue')
  },
  {
    path: '/data-center/task-center',
    name: 'TaskCenter',
    component: () => import('../views/TaskList.vue')
  },
  {
    path: '/data-center/work-data',
    name: 'WorkData',
    component: () => import('../views/WorkView.vue')
  },
  {
    path: '/data-center/comment-data',
    name: 'CommentData',
    component: () => import('../views/CommentView.vue')
  },
  {
    path: '/data-center/account',
    name: 'TargetAccount',
    component: () => import('../views/TargetAccount.vue')
  },
  {
    path: '/data-center/dfdf',
    name: 'testdfdf',
    component: () => import('../views/TestDfdf.vue')
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
